import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  useTranslate,
  FileField,
  usePermissions,
} from 'react-admin';
import ListActions from '../../components/ListActions';
import ClientsFilter from '../../components/ClientsFilter';
import TourScorms from './TourScorms';

const Scorms = (props) => {
  const translate = useTranslate();
  const { permissions } = usePermissions();
  return (
    <List
      {...props}
      actions={<ListActions {...props} tourConfig={TourScorms} hideFilters />}
      filters={<ClientsFilter />}
      bulkActionButtons={permissions === 'ADMIN'}
    >
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField
          label={translate('custom.scorms.fileName')}
          source="fileName"
        />
        <FileField
          title="Link"
          label={translate('custom.scorms.filePath')}
          source="filePath"
          target="filePath"
        />
        <TextField
          label={translate('custom.general.createdAt')}
          source="createdAt"
        />
        <TextField
          label={translate('custom.general.updatedAt')}
          source="updatedAt"
        />
      </Datagrid>
    </List>
  );
};

export default Scorms;
